import type {ConnectElementConfig} from '../ConnectElementList';

export const NestingDemoConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "nestingDemo" */ '../../../components/NestingDemo/NestingDemo'
    ),
  enabledKey: 'internal',
  releaseState: 'internal',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Internal-only demo component to establish the pattern for nesting embedded components.',
  friendlyName: 'Nesting demo',
};
